import React, { useState } from 'react';
import { FiCalendar, FiSend, FiPieChart } from 'react-icons/fi';
import EmpLeaveManagement from './EmpLeaveManagement';
import EmpLeaveBreakdownPage from './EmpLeaveBreakdownPage';
import { getCurrentFinancialYear, getFinancialYearLabel } from '../../utils/istDate';

export default function EmpLeavesAndWfh() {
  const [activeTab, setActiveTab] = useState('balance'); // 'balance' = Leave Summary, 'breakdown' = Quota Breakdown, 'apply' = Apply Leave
  const [selectedYear, setSelectedYear] = useState(getCurrentFinancialYear());

  return (
    <div className="space-y-4">
      {/* ── Top Action Buttons ── */}
      <div className="grid grid-cols-2 sm:flex sm:justify-end gap-2 sm:gap-3">
        <button
          onClick={() => setActiveTab('balance')}
          className={`flex items-center justify-center gap-2 px-4 sm:px-5 py-2.5 sm:py-3 rounded-xl text-xs sm:text-sm font-bold transition-all border ${
            activeTab === 'balance' 
              ? 'bg-slate-50 text-blue-600 border-slate-200 shadow-sm' 
              : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50 hover:text-slate-900 shadow-sm'
          }`}
        >
          <span>Leave Summary</span>
        </button>

        <button
          onClick={() => setActiveTab('apply')}
          className="flex items-center justify-center gap-2 px-4 sm:px-6 py-2.5 sm:py-3 rounded-xl text-xs sm:text-sm font-bold text-white transition-all shadow-md hover:opacity-90 hover:shadow-lg active:scale-95"
          style={{ background: 'linear-gradient(135deg, #1e40af, #3b82f6)' }}
        >
          <FiSend size={15} />
          <span>Apply Leave</span>
        </button>
      </div>

      {/* ── Header row: title + year picker ── */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 bg-white p-4 sm:p-6 rounded-xl sm:rounded-2xl border border-slate-200 shadow-sm">
        <div>
          <h1 className="text-xl sm:text-2xl font-black text-slate-900 tracking-tight">
            Leave Management
          </h1>
          <p className="text-xs sm:text-sm text-slate-500 font-medium mt-0.5 sm:mt-1">
            Manage your leave balance and applications
          </p>
        </div>

        <div className="flex items-center gap-3 w-full sm:w-auto justify-between sm:justify-end">
          <div className="flex items-center gap-2 bg-slate-50 border border-slate-200 rounded-xl px-3 py-2 text-xs font-semibold text-slate-700 w-full sm:w-auto justify-between sm:justify-start">
            <div className="flex items-center gap-2">
              <FiCalendar className="text-slate-400 shrink-0" />
              <span>Fiscal Year:</span>
            </div>
            <select
              value={selectedYear}
              onChange={(e) => setSelectedYear(Number(e.target.value))}
              className="bg-transparent font-bold text-blue-600 outline-none cursor-pointer"
            >
              {[2024, 2025, 2026, 2027].map((fy) => (
                <option key={fy} value={fy}>
                  {getFinancialYearLabel(fy)}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* ── Content View ── */}
      <div className="animate-in fade-in slide-in-from-bottom-2 duration-300">
        {activeTab === 'breakdown' ? (
          <EmpLeaveBreakdownPage
            selectedYear={selectedYear}
            onBack={() => setActiveTab('balance')}
          />
        ) : (
          <EmpLeaveManagement
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            selectedYear={selectedYear}
            setSelectedYear={setSelectedYear}
          />
        )}
      </div>
    </div>
  );
}
